export const API_URL ='https://api.satec.it.ao/api';


//export const API_URL = 'http://127.0.0.1:8000/api';